import DelegateSlideIn, {
  DelegateInfo as _DelegateInfo
} from './DelegateSlideIn';
export default DelegateSlideIn;
export type DelegateInfo = _DelegateInfo;
